import React, { useEffect } from 'react';

import Policy from '../../Manager/Checkout/Policy/Index';
import PaymentMethod from './PaymentMethod/Index';
import BillingInformation from './BillingInformation/Index';
import InvoiceTable from '../Policy/Invoices/Table';
import Wait from '../../Manager/Checkout/Wait';

import { useManagerPolicyContext } from '../../../contexts/ManagerPolicyContext';
import { useContext as usePolicyContext } from '../Policy/Context';

export default function Main({ enterpriseId }) {
  const {
    dispatch: policyDispatch,
    actions: policyActions,
    state: policyState,
  } = useManagerPolicyContext();

  const { dispatch, actions, state } = usePolicyContext();

  useEffect(() => {
    policyActions.loadPolicy(policyDispatch, policyState.enterpriseId);
    actions.load(dispatch, state.enterpriseId);
  }, []);

  return (
    <>
      {policyState.policy == null && (
        <div className="mb20">
          <Wait />
        </div>
      )}
      {policyState.policy != null && policyState.policy.id == '' && (
        <div className="ibox mt40">
          <div className="questionnaire-info-top-block">
            <div className="row display-flex">
              <div className="col-md-6 bg-content" style={{ minHeight: '510px' }}>
                <div className="ml20 mr20 mt20 mb20">
                  <h2>Billing</h2>
                  <p>Create a policy to get started!</p>
                  <p className="mt20">
                    Would you like to get the ball rolling on your Talent
                    Insurance Program? Well, it all begins with creating a
                    policy for your company. Contact our sales team to set up a
                    policy for you. - You can take it from there! So what are
                    you waiting for?
                  </p>
                  <a
                    href="https://meetings.hubspot.com/viktor-bullain"
                    target="_blank"
                    className="btn btn-green w-100 mt20"
                    rel="noreferrer"
                  >
                    Contact Sales
                  </a>
                </div>
              </div>
              <div className="col-md-6 bg-photo">
                <div className="photo bg-billing-photo" />
              </div>
            </div>
          </div>
        </div>
      )}
      {policyState.policy != null && policyState.policy.id != '' && (
        <>
          <Policy page="billing" />
          <PaymentMethod />
          <BillingInformation />

          <div className="ibox-content mt20">
            <h1>Invoice History</h1>
            <InvoiceTable adminView={false} />
          </div>
        </>
      )}
    </>
  );
}
